'use client';

import clsx from 'clsx';
import { ComponentProps, FC } from 'react';

import { Icon } from 'src/general/Icons/Icon';

import { Shade } from '../../Shade/Shade';
import { UserAvatar } from '../../UserAvatar/UserAvatar';

type Props = {
  onClick?: () => void;
  userAvatarProps?: ComponentProps<typeof UserAvatar>;
};

export const HeaderMenuActionHamburgerMobile: FC<Props> = ({
  onClick,
  userAvatarProps = {
    userData: null,
    notification: false,
    loading: false,
  },
}) => (
  <button
    className={clsx(
      'c-shade_container relative flex h-10 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-full border border-bor-pri-lig px-1.5 transition-[background] duration-200 md:hidden',
      // Styles override for the homepage
      'group-has-[.header-homepage]/body:group-[.scroll-top]/body:hover:bg-sta-on-inv-hov',
    )}
    onClick={onClick}
    title="Open menu"
    data-testid="header-menu-button-mobile"
  >
    <Shade noBackground />
    <Icon name="menu" />
    <UserAvatar {...userAvatarProps} />
  </button>
);
